module.exports = __webpack_public_path__ + "img/dashboard-landing-group.336e7f9d.svg";